import React from 'react';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';

import Root from './core/containers/Root';
import './bootstrap.scss';
import './layout.scss';

TagManager.initialize({ gtmId: process.env.REACT_APP_GOOGLE_GTAG });
const runApp = () => {
    const rootElement = document.getElementById('root');
    const root = createRoot(rootElement);
    root.render(<Root />);
};

runApp();
